import { buildAmericanFootballLiveMobileProps } from "../buildAmericanFootballLiveMobileProps";
import { getBackgroundImage } from "../../helpers";
export const buildAmericanFootballLiveDesktopProps = (event, config) => {
    return Object.assign(Object.assign({}, buildAmericanFootballLiveMobileProps(event, config)), { backgroundImage: getBackgroundImage(event, config.cmsConfig.backgroundImages) });
};
//# sourceMappingURL=buildAmericanFootballLiveDesktopProps.js.map